export const GermanCountryIso2 = "DE";
export const EmailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const DemoUrlPrefix = "demo";

export const ZipRegex: RegExp = new RegExp(/^\d{5}$/);
export const MinRadius: number = 0;
export const MaxRadius: number = 40000;

export const isRegistrationForAm = "isRegisterForAM";
